<template>
  <!-- 本地没有绑定小泥人openid 页面无需要展示  跳转至权限页获取openid-->
  <div id="app" v-if="isBindPayOpenid">
    <router-view />
  </div>
</template>

<script>
import {
  AudioId,
  apiHost,
  merchantId,
  appId,
  code,
  com_appid,
  is_eng,
  play_id,
  client,
} from "@/api/api";
import getUrlKey from "@/utils/getUrlKey";
import { isIos } from "@/utils/util";
export default {
  name: "App",
  data() {
    return {
      // 是否绑定openid
      isBindPayOpenid: true,
    };
  },
  mounted() {
   // console.log("我当前的链接是",client)
    if (client === "h5") {
      this.isBindPayOpenid = true;
      document.title = "语音导览";
      if (play_id) {
        // window.location.href = `${apiHost}/mp/audio-guide.html?merchantId=${merchantId}&ditch=move&audio_id=${AudioId}&appid=${appId}&play_id=${play_id}&is_eng=${is_eng}&client=h5`;
      }
      return;
    } 
    // // 分享进来的,监听用户进入当前页,跳转至weixin获取code
    if (!code && !sessionStorage.getItem("openIdData")) {
      let url = `${apiHost}/mp/audio-guide.html?merchantId=${merchantId}&ditch=move&audio_id=${AudioId}&appid=${appId}`;
      //  单个景点分享进来的，需携带参数 play_id is_eng 参数(针对单个景点分享功能)
      if (play_id) {
        url = `${apiHost}/mp/audio-guide.html?merchantId=${merchantId}&ditch=move&audio_id=${AudioId}&appid=${appId}&play_id=${play_id}&is_eng=${is_eng}`;
      }

      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(
        url
      )}&response_type=code&scope=snsapi_userinfo&state=STATE&component_appid=${com_appid}#wechat_redirect`;

      return;
    }
    // 分享进来的, 由于跳转两次路由,重定义返回(针对返回事件)
    if (!code && sessionStorage.getItem("openIdData")) {
      sessionStorage.clear();
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          WeixinJSBridge.call("closeWindow");
        },
        false
      );
      WeixinJSBridge.call("closeWindow");
      return;
    }
    // 没有绑定小泥人openid, 需要跳转至小泥人权限页获取小泥人的openid 供支付使用

    if (!JSON.parse(localStorage.getItem("XnrOpenidMap") || "{}")[merchantId]) {
      let url = `${apiHost}/mp/activity-bindid.html?merchantId=${merchantId}&audio_id=${AudioId}&ditch=move&appid=${appId}&name=audio-guide`;
      // 针对扫单个景点二维码或链接进来的， 需携带单数play_id is_eng
      if (play_id) {
        url = `${apiHost}/mp/activity-bindid.html?merchantId=${merchantId}&audio_id=${AudioId}&ditch=move&appid=${appId}&play_id=${play_id}&is_eng=${is_eng}&name=audio-guide`;
      }
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx809b0da3a85cd7b5&redirect_uri=${encodeURIComponent(
        url
      )}&response_type=code&scope=snsapi_base#wechat_redirect`;
      return;
    } else {
      // 解决ios手机路由状态没变化导致自定义分享无效
      if (isIos() && !sessionStorage.getItem("iosIsreload")) {
        window.location.reload(true);
        sessionStorage.setItem("iosIsreload", true);
        return;
      }
      document.title = "语音导览";
      this.isBindPayOpenid = true;
    }
  },
};
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
   width: 100%;
  height: 100%;
}
/* @font-face {
  font-family: "wack";
  src: url('//at.alicdn.com/t/font_992732_u4gt0pfn0k.ttf?t=1603462775159') format('truetype'),
}
i {
  font-size: 16px !important;
}
.wack {
  font-family: "wack" !important;
  font-size: 26px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue